import { type FlowOutputBlock, FlowProducedType } from 'flow-schema';
import * as uuid from 'uuid';

import { type ReactFlowBlockNode, type ReactFlowNode } from '../../../../types';
import { BlockType, FlowNodeType } from '../../../types';

export const defaultOutputNodeLabelPrefix = 'output';
export function getDefaultOutputNodeConfig(): FlowOutputBlock['config'] {
  return {
    data: '',
  };
}

export function createOutputNode(props: Pick<ReactFlowNode, 'position'>): ReactFlowBlockNode {
  return {
    id: uuid.v4(),
    data: {
      uiBlockType: BlockType.Output,
      label: defaultOutputNodeLabelPrefix,
      config: getDefaultOutputNodeConfig(),
      returnType: FlowProducedType.Any,
    },
    type: FlowNodeType.Block,
    ...props,
  };
}
